/**
 * Module dependencies.
 */

import { authRequest, handleRequestError } from 'src/core/utils/requests';
import { getAuthApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  email: string;
};

/**
 * Export `recoverPassword`.
 */

export async function recoverPassword({ email }: Query) {
  const endpoint = getAuthApiEndpoint('recoverPassword');

  try {
    return await authRequest.post(endpoint, { email });
  } catch (error) {
    throw handleRequestError(error);
  }
}
